import { render, staticRenderFns } from "./UsageFeesTokuyoLivingCostsTableRow.vue?vue&type=template&id=29dbdb70&scoped=true&lang=pug"
import script from "./UsageFeesTokuyoLivingCostsTableRow.vue?vue&type=script&lang=ts"
export * from "./UsageFeesTokuyoLivingCostsTableRow.vue?vue&type=script&lang=ts"
import style0 from "./UsageFeesTokuyoLivingCostsTableRow.vue?vue&type=style&index=0&id=29dbdb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dbdb70",
  null
  
)

export default component.exports